import { has } from 'lodash';
import qs from 'query-string';

export const useSearchQuery = () => {
  const query = qs.parse(location.search);
  const searchQueryHasProperty = (str: string) => has(query, str);
  return { query, searchQueryHasProperty };
};
